import { councilCustomerApi } from "@/lib/api"
import { UseMutationOptions, useMutation, useQueryClient } from "@tanstack/react-query"

const useSendMailToCustomer = (
  options?: UseMutationOptions<
    unknown,
    Error,
    { councilId: string; customerId: string; req: { subject: string; message: string } }
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: {
      councilId: string
      customerId: string
      req: {
        subject: string
        message: string
      }
    }) => {
      try {
        const response = await councilCustomerApi.sendEmailToCustomer(
          data.councilId,
          data.customerId,
          data.req,
        )
        return response.data
      } catch (error: unknown) {
        if (error && typeof error === "object" && "response" in error) {
          const err = error as { response?: { data?: { message?: string } } }
          if (err.response?.data?.message) {
            throw new Error(err.response.data.message)
          }
        }
        throw error
      }
    },
    ...options,
    onSuccess: (data, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({
        queryKey: ["customerDetail", variables.councilId, variables.customerId],
      })
      options?.onSuccess?.(data, variables, onMutateResult, context)
    },
  })
}

export default useSendMailToCustomer
